import "./TermsConditions.css";

export const TermsConditions = () => {

    return (
        <div className="privacy-components-container">
            <div className="headerPrivacy">
                <u className="title-politica">Términos y Condiciones</u>
                <p>
                    Calculadora IRL: Medidor de nivel de madurez de proyectos de innovación
                </p>
                <p>
                El uso de este sitio web está regulado por los siguientes Términos y
                Condiciones
                </p>
                <span >
                    <p className="subtitle-politica" >1 Objetivo de estos Términos y Condiciones</p>
                </span>
                <p>
                    El presente documento regula los Términos y Condiciones (en adelante “<u>T&amp;C”</u>) aplicables al acceso y uso
                    que el usuario realizará del sitio web calculadorairl.cl (en adelante el “<u>Sitio Web</u>”), así como todo
                    otro sitio web, aplicación, servicios o plataformas donde aparezcan estos T&amp;C (en adelante
                    colectivamente denominados los “<u>Sitios</u>”).
                </p>
                <span >
                    <p className="subtitle-politica" >2 Antecedentes</p>
                </span>
                <p>
                    Este proyecto es fruto de la colaboración entre APTA (<a href={"https://hubapta.com/"} target="_blank" rel="noreferrer">https://hubapta.com/</a>), HUBTEC
                    (<a href={"http://www.hubtec.cl/"} target="_blank" rel="noreferrer">http://www.hubtec.cl/</a>) y Know Hub (<a href={"https://knowhub.cl/"} target="_blank" rel="noreferrer">https://knowhub.cl/</a>). Cada uno de estos colaboradores aporta su
                    experiencia y recursos para el desarrollo y mejora de la Calculadora IRL, orientada a medir el nivel de
                    madurez de proyectos de innovación y emprendimientos.
                </p><p>
                    El Sitio Web y los Sitios son administrados de manera colaborativa por APTA, HUBTEC y Know Hub. En
                    adelante, cuando se haga referencia a cualquiera de estas entidades o a los “HUBS”, se entenderá que
                    se refiere a la acción conjunta de estas tres organizaciones.
                </p><p>
                    Con la finalidad de impulsar el desarrollo y escalabilidad de proyectos de innovación, los HUBS han
                    desarrollado la herramienta Calculadora IRL, basada en el modelo KTH Innovation Readiness Level™,
                    desarrollado por KTH Innovation bajo la licencia Creative Commons Attribution NonCommercial
                    ShareAlike 4.0 International (CC BY-NC-SA 4.0). El modelo es accesible públicamente a través del
                    siguiente enlace: <a href={"https://kthinnovationreadinesslevel.com/"} target="_blank" rel="noreferrer">https://kthinnovationreadinesslevel.com/</a>.
                </p><p>
                    Al acceder y usar este Sitio Web y los Sitios usted está aceptando los T&amp;C contenidos en este
                    documento, por lo que recomendamos que lea cuidadosamente estos T&amp;C previo al uso del Sitio Web y
                    los Sitios. Si no está de acuerdo con los T&amp;C debe dejar de utilizar los servicios contenidos en el Sitio
                    Web y/o los Sitios.
                </p><p>
                    Por último, los HUBS se reservan el derecho de modificar los T&amp;C en cualquier momento. Cada
                    actualización o modificación será publicada en el Sitio Web.
                </p>
                <span >
                    <p className="subtitle-politica" >3 Términos y Condiciones</p>
                </span>
                <p>
                    Todo el contenido del Sitio Web y los Sitios, tales como textos, herramientas, software, imágenes, entre
                    otros, es propiedad exclusiva o está licenciado a APTA, HUBTEC y Know Hub.
                </p><p>
                    El uso de los servicios del Sitio Web o los Sitios no confiere licencias de propiedad intelectual o industrial
                    sobre su contenido. Así, los HUBS se reservan todos los derechos de propiedad intelectual e industrial
                    del contenido del Sitio Web y los Sitios.
                </p><p>
                    El uso del Sitio Web y los Sitios está sujeto a la aceptación de la Política de Privacidad y Protección de
                    Datos Personales, la cual debe ser aceptada por el usuario previo a la utilización de los servicios
                    proporcionados por los HUBS. Para mayor información sobre la Política de Privacidad y Protección de
                </p><p>
                    Datos Personales visite el siguiente enlace: <a href={"https://www.calculadorairl.cl/politicas"} target="_blank" rel="noreferrer">https://www.calculadorairl.cl/politicas</a>.
                    Al acceder y utilizar los servicios contenidos en el Sitio Web y los Sitios usted está garantizando que es
                    una persona natural mayor de 18 años.
                </p>
                <span >
                    <p className="subtitle-politica" >4 Calculadora IRL</p>
                </span>
                <p>
                    Mediante el Sitio Web se proporciona acceso a la herramienta Calculadora IRL cuyo objetivo es evaluar el
                    nivel de madurez un proyecto de innovación o un emprendimiento según el modelo KTH Innovation
                    Readiness Level TM . Este modelo mide el nivel de madurez en seis dimensiones fundamentales para el
                    desarrollo y escalabilidad de un proyecto de innovación:
                </p>
                <ul>
                    <li>Customer Readiness Level (CRL): Evalúa la preparación del proyecto en relación con su base de 
                        clientes. Mide el nivel de comprensión, validación y adopción de la solución por parte del mercado objetivo, incluyendo 
                        el grado de interacción con usuarios, la validación del problema y solución, y el avance hacia ventas o compromisos comerciales.
                    </li>
                    <li>Business Readiness Level (BRL): Madurez del modelo de negocio del proyecto. Evalúa si el
                        proyecto tiene un modelo de negocio sólido y viable, incluyendo la propuesta de valor, el
                        mercado objetivo, la estrategia de ingresos y la capacidad para escalar.
                    </li><li>Technology Readiness Level (TRL): Evalúa el estado de desarrollo de la tecnología del proyecto.
                        Va desde la investigación básica y el desarrollo de prototipos hasta la validación en entornos
                        operativos reales. Indica cuán cerca está la tecnología de ser implementada comercialmente.
                    </li><li>Intellectual Property Readiness Level (IPRL): Esta dimensión busca medir el estado de desarrollo
                        de la estrategia de propiedad intelectual del proyecto. Evalúa la identificación, protección y
                        gestión de los derechos de propiedad intelectual, como patentes, marcas y derechos de autor.
                    </li><li>Team Readiness Level (TmRL): Mide las competencias, preparación y alineación del equipo del
                        proyecto. Considera la experiencia y habilidades de los miembros del equipo, así como su
                        capacidad para trabajar juntos de manera efectiva y abordar los desafíos del proyecto.
                    </li><li>Funding Readiness Level (FRL): Esta dimensión mide la preparación del proyecto para obtener
                        financiamiento. Evalúa la capacidad del equipo para identificar, asegurar y gestionar los fondos
                        necesarios para llevar el proyecto al mercado y escalar.
                    </li>
                </ul>
                <p>
                    Al acceder y utilizar la Calculadora IRL, el usuario deberá proporcionar su información personal (la cual
                    será tratada conforme a las Políticas de Privacidad y Protección de Datos Personales) y del proyecto que
                    somete a evaluación, lo cual se realizará mediante el ingreso de respuestas por parte del usuario en el

                    Sitio Web. Posteriormente, la Calculadora IRL proporcionará un informe al usuario que podrá ser
                    descargado en su computador o dispositivo móvil que contendrá información sobre el nivel de madurez
                    del proyecto en las distintas dimensiones previamente descritas.
                </p><p>
                    El acceso y utilización de la Calculadora IRL se realiza bajo la siguiente premisa:</p>
                <ul>
                    <li>Gratuito: La herramienta se pone a disposición del usuario sin costo alguno.</li>
                    <li>Información del usuario: El usuario debe ingresar datos reales y verídicos, tanto personales
                        como relativos al proyecto o emprendimiento.</li>
                    <li>Limitación de responsabilidad: Los resultados entregados por la Calculadora IRL dependen
                        exclusivamente de la información proporcionada. Los HUBS no serán responsables de
                        eventuales errores derivados de datos inexactos.</li>

                </ul>

                <p>
                    La Calculadora IRL es un instrumento de análisis inicial y no constituye asesoría técnica ni comercial
                    sobre la viabilidad del proyecto, sino únicamente consiste en una herramienta orientativa para que el
                    usuario pueda considerar en su proyecto o emprendimiento.
                </p>
                <span >
                    <p className="subtitle-politica" >5 Propiedad Intelectual</p>
                </span>
                <p>
                    Los derechos de propiedad intelectual sobre el contenido, sus características y funcionalidades (incluidas
                    imágenes, software, textos, marcas comerciales, frases de propaganda, signos distintivos, videos,
                    audios, diseño, organización de bases de datos, entre otros) del Sitio Web, los Sitios y la Calculadora IRL
                    pertenece de forma exclusiva a los HUBS o cuentan con su autorización por sus respectivos titulares de
                    los derechos de propiedad intelectual para usarlos. Los derechos de propiedad intelectual han sido
                    protegidos según su categoría por los HUBS o sus titulares, en la forma de marcas comerciales, obras,
                    patentes, modelos de utilidad u otros, ya sea en Chile o en el extranjero.
                </p>
                <p>
                    El uso del Sitio Web, los Sitios y/o la Calculadora IRL no implica la transferencia de titularidad ni el
                    otorgamiento de licencias sobre los derechos de propiedad a los usuarios. Por lo tanto, los HUBS retiene
                    todos los derechos de propiedad intelectual, incluyendo el software de la Calculadora IRL.
                </p>
                <p>
                    Los usuarios solamente pueden usar el Sitio Web y los Sitios, incluyendo la Calculadora IRL, de forma no
                    comercial. Está prohibido reproducir, modificar, comunicar públicamente, distribuir o eliminar los avisos
                    de titularidad o autoría de propiedad intelectual de cualquier contenido del Sitio Web y los Sitios.
                </p>
                <span >
                    <p className="subtitle-politica" >6 Usos Prohibidos</p>
                </span>
                <p>
                    El usuario solo puede realizar un uso lícito del Sitio Web, los Sitios y la Calculadora IRL. El propósito del
                    uso se enmarca en la evaluación de la maduración de proyectos de investigación y/o emprendimiento,
                    como un insumo para el desarrollo, escalamiento o comercialización de la tecnología materia del
                    proyecto.</p>
                <p>
                    Así, el usuario no podrá utilizar el Sitio Web, los Sitios o la Calculadora IRL de las siguientes maneras:
                </p>
                <ul>
                    <li>Violando cualquier ley o norma, sea nacional o extranjera;</li>
                    <li>Engañando a terceras personas, sean menores de edad o adultos, o utilizando los contenidos del
                        Sitio Web y/o los Sitios de forma abusiva;</li>
                    <li>Violando o apropiándose de los derechos de propiedad intelectual de terceros;</li>
                    <li>Transmitiendo o proporcionando información sujeta a deberes de confidencialidad, o datos
                        personales de terceros que no han autorizado su divulgación;</li>
                    <li>Suplantando la identidad de los HUBS, sus ejecutivos, empleados o colaboradores;</li>
                    <li>Realizando acciones que vulneren la integridad de grupos o personas o que fomenten
                        contenidos violentos;</li>
                    <li>En general, realizar o intentar vulnerar la seguridad del Sitio Web o los Sitios, con medidas tales
                        como:
                        <ul>
                            <li>Transmitir virus, troyanos, gusanos, bombas de tiempo, bots, registradores de teclado,
                                spyware, adware o cualquier otro programa nocivo o código informático diseñado para
                                afectar negativamente la operación de cualquier hardware o software informático.</li>
                            <li>Usar robots, arañas u otro dispositivo, proceso o medio automático para acceder al Sitio
                                Web para cualquier propósito, incluido monitorear o copiar cualquier material del sitio
                                web.</li>
                            <li>Usar procesos manuales para monitorear o copiar cualquier material en el Sitio Web o
                                los Sitios sin consentimiento expreso de los HUBS.</li>
                            <li>Usar dispositivos o software que interfiera con el correcto funcionamiento del Sitio
                                Web.</li>
                            <li>Intentar obtener acceso no autorizado, interferir, dañar o interrumpir cualquier parte
                                del sitio web, el servidor en el que está almacenado el sitio web o cualquier servidor,
                                computadora o base de datos conectada al sitio web.</li>

                        </ul>

                    </li>
                    <li>Efectuando cualquier actividad que impida que otros usuarios puedan acceder y/o utilizar los
                        contenidos o herramientas del Sitio Web y los Sitios.</li>
                    <li>Incumpliendo de cualquier forma estos T&amp;C.</li>
                </ul>


                <span >
                    <p className="subtitle-politica" >7 Derechos de Terceros</p>
                </span>
                <p>
                    El Sitio Web y los Sitios pueden contener links a otros sitios web de terceros, que están sujetos a las
                    otros términos y condiciones. Los HUBS no otorgan garantías sobre los términos y condiciones de dichos
                    sitios web, por lo que se sugiere que revise dicha información al momento de ingresar a cada sitio web
                    de un tercero. Los HUBS no son responsables del uso que usted realice en dichas plataformas.
                </p>
                <p>
                    El Sitio Web y los Sitios podrían contener widgets de redes sociales como Twitter, Facebook y LinkedIn, y
                    otras funciones que pueden recopilar información personal y datos de uso, y pueden configurar Cookies
                    en los dispositivos del usuario. Dichos widgets y funciones de redes sociales podrían ser alojados por un
                    tercero. Los HUBS no son responsables del funcionamiento de dichos widgets y funciones, y cualquier

                    uso estará regulado por los términos y condiciones del proveedor de dichos widgets y funciones, y no a
                    estos T&amp;C.
                </p>
                <span >
                    <p className="subtitle-politica" >8 Información recopilada en el Sitio Web</p>
                </span>
                <p>
                    Los usuarios son responsables de forma exclusiva de la información suministrada al Sitio web y los Sitios.
                    Por lo tanto, los HUBS no serán responsables en caso de que el usuario ingrese información incorrecta,
                    inexacta o falsa.
                </p><p>
                    Asimismo, el usuario garantiza que es el titular de los derechos de propiedad intelectual asociados al
                    proyecto o emprendimiento que ingresa en el Sitio Web y los Sitios, o que cuenta con autorización
                    previa y por escrito del legítimo titular para divulgar la información asociada al proyecto o
                    emprendimiento en el Sitio Web y los Sitios.
                </p><p>
                    Los HUBS no adquieren derechos de propiedad intelectual por el hecho de recibir las respuestas del
                    usuario en el Sitio Web y/o los Sitios. Sin embargo, el usuario autoriza a los HUBS a usar la información
                    proporcionada para analizar las respuestas y entregar un resultado mediante la Calculadora IRL, así como
                    también para fines de investigación, estadísticos y de análisis de tendencias de la industria.
                </p><p>
                    El usuario declara conocer y aceptar que los HUBS podrán compartir dicha información con entidades
                    gubernamentales, tales como la Agencia Nacional de Investigación (ANID) u otras, así como también
                    proveedores de servicios para el análisis de la información proporcionada. Las autorizaciones descritas
                    en el presente párrafo tendrán el carácter de gratuitas.
                </p>
                <span >
                    <p className="subtitle-politica" >9 Confidencialidad y uso de la información</p>
                </span>
                <p>
                    Se considera “Información Confidencial” todos los documentos, información técnica y financiera,
                    software, patentes, licencias, marcas, diseños, procedimientos, fórmulas, inventos, archivos, bases de
                    datos, memorándums, informes, documentación, pautas, minutas, modelos, descripciones, cálculos,
                    notas, que el usuario proporcione a los HUBS al utilizar el Sitio Web o los Sitios, siempre que el usuario
                    haya informado previamente por escrito a los HUBS el carácter de confidencial de dicha información.
                </p><p>
                    No constituye información confidencial la siguiente:
                </p>
                <ul>
                    <li>Aquella información que, al momento de su divulgación, ya fuese de dominio público o llegare a
                        serlo con posterioridad por razones no imputables a los HUBS.</li>
                    <li>La información que es conocida de forma previa por los HUBS sin obligación de mantenerla
                        como confidencial.</li>
                    <li>La información que ha sido desarrollada independientemente por los HUBS sin utilizar la
                        Información Confidencial.</li>
                </ul>
                <p>
                    El deber de confidencialidad no aplicará en caso que los HUBS sean requeridos legalmente o bien por
                    medio de un requerimiento judicial o administrativo para divulgar la Información Confidencial entregada
                    por el usuario. En dicho caso, los HUBS darán aviso al usuario tan pronto le sea posible - siempre que
                    dicho aviso sea permitido bajo la ley aplicable - a efectos de permitir que el usuario tome las acciones
                    que estime necesarias para proteger su Información Confidencial.
                </p><p>
                    Los HUBS se comprometen a mantener la confidencialidad de la información según lo descrito en el
                    primer párrafo de esta sección por un período de 3 años contados desde que el usuario entrega la
                    información. Lo anterior, con la salvedad de lo descrito en la sección anterior relativa a aquellos terceros
                    con los que los HUBS podrán compartir la información entregada por el usuario.
                </p>
                <span >
                    <p className="subtitle-politica" >10 Protección de Datos Personales</p>
                </span>
                <p>
                    Para tener mayor información acerca de nuestra Política de Privacidad y Protección de Datos Personales
                    acceda al siguiente enlace: <a href={"https://calculadorairl.cl/condiciones"} target="_blank" rel="noreferrer">https://calculadorairl.cl/condiciones</a>.
                </p>
                <span >
                    <p className="subtitle-politica" >11 Indemnidad</p>
                </span>
                <p>
                    El usuario del Sitio Web y los Sitios se compromete a mantener, indemnizar y liberar a los HUBS de toda
                    responsabilidad y cualquier daño, perjuicio y/o gasto (incluidos honorarios de abogados) que pueda
                    sufrir o incurrir en razón de cualquier demanda reclamo o la defensa de cualquier demanda que derive
                    de cualquier incumplimiento de estos T&amp;C o uso no autorizado de los contenidos del Sitio Web y/o los
                    Sitios.
                </p><p>
                    Los HUBS, a su discreción, podrán asumir la defensa ante cualquier reclamo que reciba con ocasión a un
                    incumplimiento de estos T&amp;C de parte de un usuario del Sitio Web o los Sitios.
                </p>
                <span >
                    <p className="subtitle-politica" >12 Exclusión de Responsabilidad</p>
                </span>
                <p>
                    Los HUBS se han esforzado en diseñar y mantener la Calculadora IRL para que sea una herramienta útil
                    para el ecosistema I+D+i+e. Sin embargo, ningún sistema informático o aplicación es cien por ciento
                    seguro. Por lo tanto, el acceso y utilización a la Calculadora IRL y su uso será “tal como está” en el Sitio
                    Web.</p><p>
                    No se otorgan garantías sobre el funcionamiento de la Calculadora IRL o de cualquier otro tipo.
                    Asimismo, no se garantiza que los resultados de la herramienta sean fidedignos o que no se produzcan
                    errores durante su utilización.
                </p><p>
                    El uso de la Calculadora IRL es de responsabilidad exclusiva del usuario. Los HUBS no son responsables de
                    daños o gastos directos o indirectos, incidentales, o de cualquier tipo ocurridos por el uso de la
                    Calculadora IRL o cualquier herramienta o contenido del Sitio Web y los Sitios.
                </p><p>
                    Por último, no se garantiza el acceso ininterrumpido a la Calculadora ni sus actualizaciones. En efecto, el
                    acceso al Sitio Web y, por ende, a la Calculadora IRL puede ser interrumpido por mantenimiento,
                    actualizaciones u otras razones a discreción de los HUBS.
                </p>
                <span >
                    <p className="subtitle-politica" >13 Ley Aplicable y Jurisdicción</p>
                </span>
                <p>
                    La legislación aplicable a estos T&amp;C corresponde a la de la República de Chile. Para todos los efectos, el
                    domicilio aplicable a estos T&amp;C corresponde a la comuna y ciudad de Santiago, y los tribunales llamados
                    a la resolución de controversias respecto a la interpretación o aplicación de estos T&amp;C corresponden a
                    los Tribunales Ordinarios de Justicia.
                </p>
                <span >
                    <p className="subtitle-politica" >14 Informaciones y Comunicaciones</p>
                </span>
                <p>
                    Esta herramienta considera una administración compartida por los HUBS:</p>
                <ul>
                    <li>
                        APTA<br></br>
                        Domicilio postal: El Director 6000, oficina 203, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@hubapta.com"} target="_blank" rel="noreferrer">calculadora@hubapta.com</a>
                    </li><li>
                        HUBTEC<br></br>
                        Domicilio postal: Av. Apoquindo 2827, Piso 12, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@hubtec.cl"} target="_blank" rel="noreferrer">calculadora@hubtec.cl</a>
                    </li><li>
                        Know Hub<br></br>
                        Domicilio postal: Av. Nueva Tajamar 481, Oficina 905 Torre Norte, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@knowhub.cl"} target="_blank" rel="noreferrer">calculadora@knowhub.cl</a>
                    </li>
                </ul>

                <p>Puede contactarse a través de los correos postales o a través de los correos electrónicos previamente
                    mencionados.
                </p>
                <span >
                    <p className="subtitle-politica" >15 Modificaciones</p>
                </span>
                <p>Es posible que se actualicen estos T&amp;C. La fecha en que se actualizó por última vez estos T&amp;C se
                    identifica en la parte final del presente documento. Las modificaciones a estos T&amp;C serán publicados en
                    esta página web.</p>
                <span >
                    <p className="subtitle-politica" >16 Fecha de Elaboración</p>
                </span>
                <p>Estos T&amp;C han sido elaborados con fecha de 14 de marzo de 2025.</p>

            </div>



        </div >


    )

};
